<div class="modal-header">
  <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  @if (warning) {
    <div class="text-danger mb-3" id="confirmation-warning">
      <i class="fa-solid fa-triangle-exclamation fa-lg"></i> {{ warning }}
      @if (warningDetails.length) {
        <ul class="mb-0 mt-1">
          @for (detail of warningDetails; track $index) {
            <li>{{ detail }}</li>
          }
        </ul>
      }
    </div>
  }

  <p>{{ message }}</p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="yes()">Yes</button>
  <button type="button" class="btn btn-outline-secondary" (click)="no()">No</button>
</div>
